export var componentsLocales = {
  selectMonthAriaLabel: 'месяц',
  selectYearAriaLabel: 'год',
  selectChosenAriaLabel: 'Выбранный',
  selectChooseAriaLabel: 'Выбрать'
};